// src/components/layout/MainLayout.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { setupRevealAnimations } from '../../utils/helpers';

const MainLayout = ({ children }) => {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  // Set up animations
  useEffect(() => {
    setupRevealAnimations();
    
    // Re-initialize reveal animations when children change
    const observer = new MutationObserver(() => {
      setupRevealAnimations();
    });
    
    if (document.querySelector('main')) {
      observer.observe(document.querySelector('main'), {
        childList: true,
        subtree: true
      });
    }
    
    return () => observer.disconnect();
  }, [children]);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      {/* Adjusted main element to not have padding-top, as that's handled by each page */}
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;